import _ from "lodash";
import React from 'react';
import PropTypes from 'prop-types';

import PropertyPanel from "Components/PropertyPanel";
import MediaSelectModal from "Components/MediaSelectModal";
import MediaPreview from "Components/MediaPreview";

import BorderRadius from "Components/Properties/BorderRadius";
import AltText from "Components/Properties/AltText";

export default class ImagePropertiesSidebar extends React.Component
{
    state = {
        selectDialog: false,
        uploadDialog: false,
        data: {
            ...this.props.element.data
        }
    };

    static propTypes = {
        element: PropTypes.object.isRequired,
        media: PropTypes.array.isRequired,

        onChanging: PropTypes.func.isRequired,
        onChanged: PropTypes.func.isRequired,

        bringElementForward: PropTypes.func.isRequired,
        sendElementBackward: PropTypes.func.isRequired,
        bringElementToFront: PropTypes.func.isRequired,
        sendElementToBack: PropTypes.func.isRequired,
    };

    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            data: {
                ...props.element.data
            }
        };
    }

    handleChangingData = (key, value) => {
        this.props.onChanging(
            this.props.element.id,
            {
                data: {
                    ...this.state.data,
                    [key]: value
                }
            }
        );

        setTimeout(this.onBlur);
    };

    onBlur = () => {
        this.props.onChanged(this.props.element.id);
    };

    render()
    {
        const file = _.find(this.props.media, ['id', this.props.element.data.media_id]);

        return <>

            <PropertyPanel title='Content' defaultOpen>

                <MediaPreview src={file ? file.filename : null} onClick={() => this.setState({selectDialog: true})} />

                <MediaSelectModal
                    open={this.state.selectDialog}
                    onClose={() => this.setState({selectDialog: false})}
                    media={this.props.media}
                    value={this.props.element.data.media_id}
                    onChange={mediaId => this.handleChangingData('media_id', mediaId)}
                />

            </PropertyPanel>

            <PropertyPanel title='Rounded Corners'>
                <BorderRadius
                    value={this.props.element.data.borderRadius ?? '0'}
                    onChange={borderRadius => this.handleChangingData('borderRadius', borderRadius)}
                    onBlur={this.onBlur}
                />
            </PropertyPanel>

            <PropertyPanel className='space-y-4' title='Alt Text'>
                <AltText
                    value={this.props.element.data.altText ?? ''}
                    onChange={altText => this.handleChangingData('altText', altText)}
                    onBlur={this.onBlur}
                />
            </PropertyPanel>

        </>;
    }
}
